import { render, staticRenderFns } from "./KitAuthentication.vue?vue&type=template&id=0b8e5b8f"
import script from "./KitAuthentication.vue?vue&type=script&lang=js"
export * from "./KitAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports